const onLoad = async () => {
  const attribNode = document.getElementById('libraryAttributes');
  if (attribNode) {
    attribNode.innerHTML = Object.keys(window.emuiDiagnostics || {}).reduce(
      // eslint-disable-next-line no-return-assign, no-param-reassign
      (value, attribute) => (value += `<li>${attribute}</li>`),
      '',
    );
  }

  const { logger, http, logUnhandledErrors, webvitals } =
    window.emuiDiagnostics;
  if (logger) {
    window.logger = logger({
      transport: http('https://int.api.ellielabs.com/diagnostics/v2/logging'),
      index: 'pui',
      environment: 'dev',
      team: 'ui platform',
      appName: 'diagnostics demo',
      appVersion: '1.0.0',
      instanceId: '',
      userId: '',
    });

    webvitals(window.logger);
    logUnhandledErrors(window.logger);
    window.logger.info('application started');
  } else console.warn('ui logger missing');

  const unhandledErrorBtn = document.getElementById('unhandledErrorBtn');
  unhandledErrorBtn.addEventListener('click', () => {
    throw new Error('This is an unhandled error');
  });

  const rejectedPromiseBtn = document.getElementById('rejectedPromiseBtn');
  rejectedPromiseBtn.addEventListener('click', () => {
    Promise.reject(new Error('This is a rejected promise'));
  });

  const submitBtn = document.getElementById('submitBtn');
  const msgEle = document.getElementById('message');
  const levelEle = document.getElementById('level');
  const outputEle = document.getElementById('output');
  submitBtn.addEventListener('click', () => {
    const msg = msgEle.value;
    if (!msg) {
      alert('Please enter a message');
      return;
    }
    const level = levelEle.value;
    if (!level) {
      alert('Please select a log level');
      return;
    }
    window.logger[level](msg);
    outputEle.value = `Logged message: ${msg} with level: ${level}`;
    // setTimeout(() => {
    //   outputEle.value = '';
    // }, 5000);
  });
};

window.addEventListener('load', onLoad);
